import React, { useState } from "react";
import styles from "./RaffleTable.module.sass";
import Loader from "../../../components/Loader";
import Row from "./Row";
import TemplateModal from "../../NewProduct/TemplateModal";
import CreateProduct from "../CreateProduct";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import raffle from "../../../i11/Raffle";
import { useUser } from "../../../context";
import { Pager } from "../../../components/Pager";
import { rafflePageLimit } from "..";

const RaffleTable = ({ items, loading, getData, rest }) => {
	const { locale } = useUser();
	const { isOpen, onOpen, onClose } = UseDisclosure();
	const [editData, setEditData] = useState();
	const total = Math.ceil((items?.list_count || 1) / rafflePageLimit);
	return (
		<div>
			{loading ? (
				<div className={styles.center}>
					<Loader />
				</div>
			) : (
				<div className={styles.table}>
					<div className={styles.row}>
						<div className={styles.col}></div>
						<div className={styles.col}>{raffle[locale].name}</div>
						<div className={styles.col}>
							{raffle[locale].status}
						</div>
						<div className={styles.col}>
							{raffle[locale].end_date}
						</div>
					</div>
					{items?.list?.map((x, index) => (
						<Row
							item={x}
							key={index}
							index={index}
							onEdit={() => {
								setEditData(x);
								onOpen();
							}}
							getData={getData}
						/>
					))}
				</div>
			)}
			<br />
			<div className={styles.center}>
				<Pager {...rest} total={total} />
			</div>
			<TemplateModal visible={isOpen} onClose={onClose}>
				{isOpen && (
					<CreateProduct
						close={onClose}
						editData={editData}
						getData={getData}
					/>
				)}
			</TemplateModal>
		</div>
	);
};

export default RaffleTable;
